import type { FilterPopoverProps } from 'src/common/primitives/FilterPopover/FilterPopover';
import { FilterPopoverTrigger } from 'src/common/primitives/FilterPopover/FilterPopoverTrigger';
import { MultiSelectFilterPopover } from 'src/common/primitives/FilterPopover/MultiSelectFilterPopover';
import { spaceTypes } from 'src/common/spaceTypes';

type IdentifiedSpaceType = {
  id: string;
  label: string;
};

// Extracts ID string from list
function unwrapSpaceTypeList(list: IdentifiedSpaceType[]): string[] {
  return list.map((p) => p.id);
}

function createIdentifiedList(list: string[]) {
  return list.map((s) => ({
    id: s,
    label: s,
  }));
}

export default function SpaceTypeColumnFilter({
  selected,
  open,
  triggerElement,
  onApply,
  onClose,
}: {
  selected: string[];
  open?: boolean;
  triggerElement?: FilterPopoverProps['triggerElement'];
  onApply: (spaceTypes: string[]) => void;
  onClose?: () => void;
}) {
  const spaceTypeOptions = spaceTypes.map((spaceType) => ({
    id: spaceType,
    label: spaceType,
  }));

  return (
    <MultiSelectFilterPopover
      open={open}
      value={createIdentifiedList(selected)}
      filters={spaceTypeOptions}
      renderLabel={(spaceType) => spaceType.label}
      triggerElement={
        triggerElement ?? (
          <FilterPopoverTrigger count={selected.length} label="Space Type" />
        )
      }
      onChange={(value) => {
        onApply(unwrapSpaceTypeList(value));
        onClose?.();
      }}
      onCancel={onClose}
    />
  );
}
